function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 14,
  cy: 14,
  r: 14,
  fill: "#007DBA"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M11.157 12.04v7.56H8.55v-7.56h2.607zm.166-2.335c.005.37-.128.681-.4.93-.27.25-.627.374-1.07.374h-.015c-.432 0-.78-.124-1.043-.374a1.23 1.23 0 01-.395-.93c0-.377.136-.688.407-.935.271-.247.625-.37 1.062-.37.437 0 .788.123 1.05.37.264.247.398.558.404.935zm3.87 3.409c.1-.153.203-.287.308-.403.111-.122.26-.255.447-.397.187-.143.416-.253.687-.332.271-.079.573-.118.904-.118.901 0 1.625.288 2.173.866.547.577.821 1.423.821 2.536V19.6h-2.599v-4.044c0-.534-.106-.952-.32-1.255-.213-.302-.546-.454-.999-.454-.331 0-.61.088-.833.264a1.63 1.63 0 00-.502.652 1.787 1.787 0 00-.087.618V19.6h-2.598c.01-2.03.015-3.675.015-4.936 0-1.262-.002-2.014-.008-2.259l-.007-.366h2.598v1.075z"
}));

function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28
  }, props), _ref);
}

export default SvgLinkedin;